export default __webpack_public_path__ + "static/media/shipshap-visual.3727406d.svg";